import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import CustomiseProject from 'CustomiseProject/presentation/CustomiseProject';
import Loader from 'util/Loader';
import {expectedOrderOfCnsProceduresTemplate} from 'ImportedProjectLobby/utils/ImportedProjectUtils';
import {
  findImportedProjectById,
  findImportedProjectProcedureMilestones,
  saveImportedProject,
} from 'Projects/service/ProjectService';

export default function CustomiseProjectView(props, context) {
  const {
    params: {importedProjectId},
  } = props;
  const {router} = context;
  const [importedProject, setImportedProject] = useState(null);
  const [milestones, setMilestones] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const handleClickToggleEnableProcedure = (isInputChecked, cnsProcedure) => {
    if (isInputChecked) {
      setImportedProject((oldProject) => ({
        ...oldProject,
        importedProcedures: [...(oldProject?.importedProcedures || []), cnsProcedure],
      }));
    } else {
      setImportedProject((oldProject) => ({
        ...oldProject,
        importedProcedures: (oldProject?.importedProcedures || []).filter(
          ({id}) => id !== cnsProcedure.id,
        ),
      }));
    }
  };
  const handleClickToggleEnableMilestone = (isInputChecked, milestone) => {
    // for toggle check (true state)
    if (isInputChecked) {
      // add milestone object to importedProject.milestones array
      // and also add procedures of those milestones into importedProject.importedProcedures array

      setImportedProject((oldProject) => {
        const importedMilestones = oldProject?.milestones || [];
        const importedProcedures = oldProject?.importedProcedures || [];
        const milestoneMatch = milestones.find(({milestone: {id}}) => id === milestone.id);
        const cnsProcedures = milestoneMatch?.cnsProcedures || [];

        return {
          ...oldProject,
          milestones: [...importedMilestones, milestone],
          importedProcedures: [...importedProcedures, ...cnsProcedures],
        };
      });
    } else {
      setImportedProject((oldProject) => {
        const importedMilestones = oldProject?.milestones || [];
        const importedProcedures = oldProject?.importedProcedures || [];
        const milestoneMatch = milestones.find(({milestone: {id}}) => id === milestone.id);
        const cnsProcedures = milestoneMatch?.cnsProcedures || [];

        return {
          ...oldProject,
          milestones: importedMilestones.filter(({id}) => id !== milestone.id),
          importedProcedures: importedProcedures.filter(
            ({id}) => !cnsProcedures.find(({id: procedureId}) => procedureId === id),
          ),
        };
      });
    }
  };
  const handleSaveBtnClick = async () => {
    // save the project to the database and then push the page to timeline view

    await saveImportedProject(importedProject);

    router.push({pathname: `/Projects/${importedProjectId}`});
  };

  useEffect(() => {
    const handleRetrieveProject = async () => {
      const project = await findImportedProjectById(importedProjectId);

      setImportedProject(project);
    };
    const handleRetrieveMilestones = async () => {
      const milestones = await findImportedProjectProcedureMilestones(importedProjectId);
      // sort cnsProcedures for milestone 2 [construct: targeting vector]
      const {cnsProcedures} = milestones[1];

      cnsProcedures.sort(
        (a, b) =>
          expectedOrderOfCnsProceduresTemplate.indexOf(a.name) <
          expectedOrderOfCnsProceduresTemplate.indexOf(b.name),
      );

      setMilestones(milestones);
      setIsLoading(false);
    };

    if (isLoading && !!importedProjectId) {
      handleRetrieveProject();
      handleRetrieveMilestones();
    }
  }, [isLoading, importedProjectId]);

  return isLoading ? (
    <Loader label="Loading Project Data" />
  ) : (
    <CustomiseProject
      importedProject={importedProject}
      milestones={milestones}
      onClickSaveBtn={handleSaveBtnClick}
      onToggleEnableProcedure={handleClickToggleEnableProcedure}
      onToggleEnableMilestone={handleClickToggleEnableMilestone}
    />
  );
}

CustomiseProjectView.propTypes = {
  params: PropTypes.object,
};
CustomiseProjectView.contextTypes = {
  router: PropTypes.object.isRequired,
};
CustomiseProjectView.defaultProps = {
  params: null,
};
